module.exports = "/assets/data/fbd1ba4b290ebd8b26127325c7962ef0-IP26.data.json";